import packingRequest from "../request/packing"

const apiRequest = packingRequest()

export const createShippingRule = (data) => {
    return apiRequest({
        url: '/packing/shipping/rules',
        method: 'POST',
        data: data
    })
}

export const getDetailShippingRule = (id) => {
    return apiRequest({
        url: `/packing/shipping/rules/${id}`,
        method: 'GET'
    })
}

export const updateShippingRule = (id, data) => {
    return apiRequest({
        url: `/packing/shipping/rules/${id}`,
        method: 'PUT',
        data: data
    })
}

export const listPlatform = () => {
    return apiRequest({
        url: `/packing/platforms`,
        method: 'GET'
    })
}

export const detectCarrierShippingRule = async (args = {}) => {
    const {data} = await apiRequest({
        url: '/packing/line-ship',
        method: 'PUT',
        data: args
    })

    return data
}

export const getShippingRuleHistory = (shippingId, page, limit) => {
    return apiRequest({
        url: `/packing/shipping/rule/${shippingId}/history?page=${page}&limit=${limit}`,
        method: 'GET'
    })
}

export const getSkuVariants = (data = {}) => {
    return apiRequest({
        url: `/packing/shipping/sku-variants`,
        method: 'GET',
        params: data
    })
}

export const searchProcessHistories = (payload) => {
    return apiRequest({
        url: `/packing/histories/search`,
        method: 'POST',
        data: payload,
    })
}

export const notiCombineShip = () => {
    return apiRequest({
        url: `/packing/barcode-combine-ship/noti`,
        method: 'GET',
    })
}

export default {
    createShippingRule,
    getDetailShippingRule,
    updateShippingRule,
    listPlatform,
    detectCarrierShippingRule,
    getShippingRuleHistory,
    getSkuVariants
}
